var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, AlertTitle } from "@mui/material";
import clsx from "clsx";
import styles from "./notification.module.css";
export const Notification = (_a) => {
    var { title, centered, children } = _a, props = __rest(_a, ["title", "centered", "children"]);
    const sx = centered ? { display: "flex", justifyContent: "center" } : {};
    return (_jsxs(Alert, Object.assign({ className: clsx(styles.wrapper), sx: sx }, props, { children: [title && _jsx(AlertTitle, { children: title }), children] })));
};
